import React from 'react'
import OfferListDataTable from '../../components/common/OfferList';

const OfferList = () => {
  return (
    <div className="offer-list-page-container">
      <OfferListDataTable />
    </div>
  )
}

export default OfferList;